import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'

export default createListViewComponent({
  entityName: entityNames.locationGroups,
  createButtonTextId: 'createLocationGroup',
  primaryLinkTarget: 'locationGroupRecord',
  transformGetItemsParams: (self) => ({ includeAllLocationGroups: true }),
})()
